import React, { useEffect, useState } from "react";
import CanvasDisplay from "../../../../Canvas/components/canvas-core/CanvasDisplay";
import CanvasPageRenderer from "../../../../Canvas/components/CanvasPageRenderer";
import { getPages } from "../../../../SectionElements/plugins/utils";

const PreviewCanvas = ({ version_content }) => {
  const { short_description } = version_content || {};
  const canvasLabel = version_content?.canvas_label || version_content?.pageTitle || "Canvas";
  const jsonFileUrl = version_content?.canvas_json_data_file;

  const [canvasJsonData, setCanvasJsonData] = useState(null);
  const [fetchDone, setFetchDone] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (!jsonFileUrl) {
      setFetchDone(true);
      return;
    }
    setFetchDone(false);
    setFetchError(null);
    let cancelled = false;
    fetch(jsonFileUrl, { mode: "cors", credentials: "omit", cache: "no-cache" })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load canvas: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        setFetchDone(true);
        if (data) setCanvasJsonData(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setFetchDone(true);
          setFetchError(err?.message || "Failed to load canvas");
        }
      });
    return () => { cancelled = true; };
  }, [jsonFileUrl]);

  const rawPages = getPages(version_content) || [];
  const pages = Array.isArray(rawPages)
    ? rawPages
        .map((page, index) => {
          if (typeof page === "object" && page !== null && (page.canvas_page_id || page.page_id)) {
            return page;
          }
          if (typeof page === "string") {
            return {
              canvas_page_id: `preview-canvas-page-${index}`,
              page_id: `preview-canvas-page-${index}`,
              canva_snap_url: page,
              pageOrder: index,
              created_at: new Date().toISOString(),
            };
          }
          return null;
        })
        .filter(Boolean)
    : [];

  const hasFullCanvas =
    canvasJsonData &&
    (Array.isArray(canvasJsonData)
      ? canvasJsonData.length > 0
      : canvasJsonData?.pages?.length > 0 || canvasJsonData?.results?.pages?.length > 0);

  return (
    <div>
      <div style={{ padding: "20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            paddingBottom: "20px",
            borderBottom: "3px double #e0e0e0",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input type="checkbox" defaultChecked={true} readOnly disabled />
            <h2 style={{ margin: 0, fontSize: "23px" }}>{canvasLabel}</h2>
          </div>
        </div>

        {short_description && (
          <div style={{ marginLeft: "4px", marginTop: "-10px", marginBottom: "20px" }}>
            <p style={{ whiteSpace: "pre-wrap" }}>{short_description}</p>
          </div>
        )}

        {jsonFileUrl && !fetchDone && (
          <div style={{ marginTop: "10px", textAlign: "center", color: "#666" }}>Loading canvas…</div>
        )}

        {fetchError && (
          <div style={{ marginTop: "10px", textAlign: "center", color: "#c00" }}>{fetchError}</div>
        )}

        {hasFullCanvas && (
          <div style={{ marginTop: "16px" }}>
            <CanvasPageRenderer
              canvasData={canvasJsonData}
              width={Math.min(typeof window !== "undefined" ? window.innerWidth * 0.5 : 500, 600)}
              showSnapshots={false}
            />
          </div>
        )}

        {!hasFullCanvas && fetchDone && pages.length > 0 && <CanvasDisplay pages={pages} />}

        {!hasFullCanvas && fetchDone && pages.length === 0 && !fetchError && (
          <div style={{ marginLeft: "4px", marginTop: "10px", color: "#888" }}>
            <p>No canvas pages to display</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviewCanvas;
